// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tooltip {
    position: absolute;
    background-color: rgba(0, 0, 0, 0.75);
    color: #fff;
    padding: 5px 10px;
    font-size: 1em;
    border-radius: 5px;
    pointer-events: none;
    transform: translate(-50%, -100%);
    white-space: nowrap;
    z-index: 1000;
  }`, "",{"version":3,"sources":["webpack://./src/components/CustomTooltip.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;IACjC,mBAAmB;IACnB,aAAa;EACf","sourcesContent":[".custom-tooltip {\n    position: absolute;\n    background-color: rgba(0, 0, 0, 0.75);\n    color: #fff;\n    padding: 5px 10px;\n    font-size: 1em;\n    border-radius: 5px;\n    pointer-events: none;\n    transform: translate(-50%, -100%);\n    white-space: nowrap;\n    z-index: 1000;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
